import type { SupportedLocale } from '@/i18n/config';
import {
  arDriveManagementCopy,
  deDriveManagementCopy,
  enDriveManagementCopy,
} from '@/i18n/drives-management-copy-en-ar-de';
import {
  esDriveManagementCopy,
  frDriveManagementCopy,
  hiDriveManagementCopy,
} from '@/i18n/drives-management-copy-es-fr-hi';
import {
  idDriveManagementCopy,
  itDriveManagementCopy,
  jaDriveManagementCopy,
  koDriveManagementCopy,
} from '@/i18n/drives-management-copy-id-it-ja-ko';
import {
  ruDriveManagementCopy,
  viDriveManagementCopy,
} from '@/i18n/drives-management-copy-ru-vi';
import {
  zhDriveManagementCopy,
  zhTwDriveManagementCopy,
} from '@/i18n/drives-management-copy-zh';
import type { DriveManagementCopy } from '@/i18n/drives-management-copy-types';
import { ptBrDriveManagementCopy } from '@/i18n/drives-management-copy-pt-br';

const COPY: Record<SupportedLocale, DriveManagementCopy> = {
  en: enDriveManagementCopy,
  'pt-BR': ptBrDriveManagementCopy,
  ar: arDriveManagementCopy,
  de: deDriveManagementCopy,
  es: esDriveManagementCopy,
  fr: frDriveManagementCopy,
  hi: hiDriveManagementCopy,
  id: idDriveManagementCopy,
  it: itDriveManagementCopy,
  ja: jaDriveManagementCopy,
  ko: koDriveManagementCopy,
  ru: ruDriveManagementCopy,
  vi: viDriveManagementCopy,
  zh: zhDriveManagementCopy,
  'zh-TW': zhTwDriveManagementCopy,
};

export function getDriveManagementCopy(
  locale: SupportedLocale
): DriveManagementCopy {
  return COPY[locale];
}

export type { DriveManagementCopy } from '@/i18n/drives-management-copy-types';
